module.exports = __webpack_public_path__ + "static/media/mexico.f5ead639.png";